// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-loader[data-v-6428c8d2] {\n  padding-top: 3.7rem;\n  align-items: start;\n  position: fixed;\n  background: unset !important;\n}\n", ""]);
// Exports
module.exports = exports;
